import ConsignmentStocksFilters from "./Filters.vue"
import ConsignmentStock from "../../models/ConsignmentStock"
import Granite from "../../models/Granite"
import storage from "../../services/storage"

const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000

export default {
  components: {
    ConsignmentStocksFilters
  },

  data() {
    return {
      loading: false,
      pagination: {
        rowsPerPage: -1,
        sortBy: "due_on",
      },
      consignmentStocks: [],
    }
  },

  computed: {
    noResults() {
      return this.consignmentStocks.length === 0
    },

    amountTotal() {
      return Math.floor(this.consignmentStocks.reduce((a, e) => a + (parseFloat(e.amount, 10) || 0), 0))
    },

    isProduction() {
      return process.env.NODE_ENV === "production"
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    statusFor(consignmentStock) {
      switch (consignmentStock.status) {
        case "ordered": return "Commandé"
        case "shipping": return "En livraison"
        case "delivered": return "Livré"
        case "renewable": return "À renouveler"
        case "renewed": return "Renouvelé"
        case "billable": return "À facturer"
        case "billing": return "En facturation"
      }
    },

    placementFor(consignmentStock) {
      switch (consignmentStock.placement) {
        case "unknown": return "inconnu"
        case "pallet": return "palette"
        case "exposition": return "exposé"
      }
    },

    imageStatusFor(consignmentStock) {
      if (consignmentStock.image.taken_on) {
        const takenOn = new Date(consignmentStock.image.taken_on).getTime()
        if (takenOn < (Date.now() - MILLISECONDS_PER_DAY * 90)) {
          return { icon: "check_circle_outline", color: "warning", title: "Photo > 90 jours !" }
        } else {
          return { icon: "check_circle_outline", color: "success", title: "Photo sur site" }
        }
      } else if (consignmentStock.delivered) {
        return { icon: "error_outline", color: "error", title: "Pas de photo !" }
      } else {
        return { icon: "schedule", color: "grey", title: "En cours de livraison" }
      }
    },

    async load() {
      const timer = setTimeout(() => this.loading = true, 100)
      try {
        await this.filter()
      } finally {
        clearTimeout(timer)
        this.loading = false
      }
    },

    async filter(filters) {
      filters = filters || storage.get("filters:consignment_stocks")
      let consignmentStocks = await ConsignmentStock.search(filters)
      this.consignmentStocks = consignmentStocks || []
    },

    async refresh() {
      const timer = setTimeout(() => this.loading = true, 100)
      await ConsignmentStock.reload()
      await Granite.reload()
      this.filter().then(() => this.loading = false)
      clearTimeout(timer)
    },

    save(id) {
      ConsignmentStock
        .update(id, {
          monument_presence_verified: event.target.checked
        })
    },
  },
}
